import type { BatchChanges, Link, Task } from "@dhtmlx/trial-vue-gantt";
import type { InjectionKey, Ref } from "vue";

export interface CustomEditViewContext {
  tasks: Ref<Task[]>;
  links: Ref<Link[]>;
  saveTask: (task: Task) => void;
  upsertTask: (task: Task) => void;
  deleteTask: (taskId: string | number) => void;
  applyBatch: (changes: BatchChanges) => void;
}

export const CUSTOM_EDIT_VIEW_CONTEXT_KEY: InjectionKey<CustomEditViewContext> = Symbol("custom-edit-view-context");
